module.exports = __webpack_public_path__ + "static/australian-norms-103f682834275a67b65262613e87ab0e.png";